import { Tag } from 'react-tag-autocomplete';
import { arrayEqual, dateFromWeekNumber, getWeekNumber } from '.';
import { ICampaign, IDevice } from '../interfaces';
import { ENDPOINT, TOKEN } from './constants';
import XlsxPopulate from 'xlsx-populate';
import moment from 'moment';
import { Loader } from '@googlemaps/js-api-loader';
import { IEntry } from '../Components/NewCampaign/PoiManager';
import { GoogleAPI } from 'google-maps-react';

let googleMapsClient: any;

const loader = new Loader({
    apiKey: 'AIzaSyC2NQ1WprtMoAMgX0P18PGkC8Uq785ffLM',
    version: 'weekly'
});

loader.load().then((google: GoogleAPI) => {
    googleMapsClient = new google.maps.Geocoder();
});

const FACTEUR_MULTI = 1.4;
const TICKETS_CAISSE = 1500;
export const FRAIS_TECH = 0.05;

export const FACTORS = [
    [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0],
    [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0],
    [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0],
    [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0],
    [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0],
    [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0],
    [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0],
    [0.06, 0.06, 0.06, 0.07, 0.06, 0.04, 0.0],
    [0.29, 0.3, 0.28, 0.32, 0.32, 0.3, 0.05],
    [0.55, 0.58, 0.58, 0.61, 0.62, 0.7, 0.45],
    [0.84, 0.87, 0.9, 0.92, 0.95, 1.18, 1.08],
    [1.12, 1.1, 1.18, 1.2, 1.23, 1.54, 1.47],
    [1.23, 1.2, 1.3, 1.3, 1.34, 1.58, 1.16],
    [1.11, 1.09, 1.17, 1.17, 1.21, 1.37, 0.27],
    [0.95, 0.91, 0.98, 0.96, 1.04, 1.23, 0.22],
    [0.93, 0.89, 0.96, 0.93, 1.05, 1.36, 0.22],
    [1.24, 1.19, 1.22, 1.21, 1.37, 1.72, 0.26],
    [1.77, 1.69, 1.7, 1.72, 1.87, 2.06, 0.36],
    [2.07, 1.96, 2.08, 2.06, 2.14, 2.15, 0.43],
    [1.67, 1.6, 1.73, 1.65, 1.69, 1.67, 0.34],
    [0.77, 0.78, 0.83, 0.76, 0.81, 0.82, 0.13],
    [0.19, 0.18, 0.2, 0.18, 0.22, 0.23, 0.03],
    [0.03, 0.02, 0.03, 0.03, 0.04, 0.03, 0.01],
    [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.01]
];

export const numberWithSpaces = (x: number) => x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

export const getSuggestions = (devices: IDevice[]) => {
    const suggestions: Tag[] = [];
    const signSuggestions: Tag[] = [];

    devices.forEach((d) => (d.Shop.city = d.Shop.city.toUpperCase()));

    devices.forEach((d) => {
        const entries = [
            {
                name: `${d.Shop.zip}`,
                type: 'zip',
                id: d.Shop.zip
            },
            {
                name: `${d.Shop.city.toUpperCase()} (Ville)`,
                type: 'city',
                id: d.Shop.city.toUpperCase()
            },
            {
                name: `${d.Shop.departement} (Departement)`,
                type: 'departement',
                id: d.Shop.departement
            },
            {
                name: `${d.Shop.region} (Region)`,
                type: 'region',
                id: d.Shop.region
            }
        ];

        const signsEntries = [
            {
                name: `${d.Shop.Sign.name}`,
                type: 'sign',
                id: d.Shop.Sign.name
            }
        ];

        entries.forEach((e) => {
            if (!suggestions.find((s) => s.name === e.name && s.id === e.id)) {
                if (e.id) {
                    suggestions.push(e);
                }
            }
        });

        signsEntries.forEach((e) => {
            if (!signSuggestions.find((s) => s.name === e.name && s.id === e.id)) {
                if (e.id) {
                    signSuggestions.push(e);
                }
            }
        });
    });

    return { suggestions, signSuggestions };
};

export const getFilteredDevices = (
    devices: IDevice[],
    filters: {
        type: string;
        name: string;
        id: any;
    }[],
    allDevices: boolean,
    exclusion: boolean
) => {
    const selected: number[] = [];

    if (allDevices) {
        return devices.map(({ id }) => id);
    }

    if (!filters.length) {
        return selected;
    }

    for (const device of devices) {
        const matchesSign = !!filters.find((sf) => {
            if (sf.type === 'sign') {
                return device.Shop.Sign.name === sf.id;
            }

            return false;
        });

        const filterBySign = !!filters.find((sf) => sf.type === 'sign');

        const matchesOther = !!filters.find((sf) => {
            if (sf.type === 'shop') {
                return device.Shop.name === sf.id;
            } else if (sf.type === 'zip') {
                return device.Shop.zip === sf.id;
            } else if (sf.type === 'city') {
                return device.Shop.city === sf.id;
            } else if (sf.type === 'address') {
                return device.Shop.address === sf.id;
            } else if (sf.type === 'region') {
                return device.Shop.region === sf.id;
            } else if (sf.type === 'departement') {
                return device.Shop.departement === sf.id;
            }

            return false;
        });

        const filterByOther = !!filters.find((sf) => sf.type !== 'sign');

        if (!exclusion) {
            if ((!filterBySign || matchesSign) && (!filterByOther || matchesOther)) {
                selected.push(device.id);
            }
        } else {
            if (!matchesSign && !matchesOther) {
                selected.push(device.id);
            }
        }
    }

    return selected;
};

export const getShopNb = (devices: IDevice[]) => {
    const s = new Set();

    for (const d of devices) {
        if (d) s.add(d.Shop.id);
    }

    return s.size;
};

export const getShopFromDevices = (devices: IDevice[]) => {
    const shops: any = {};

    for (const d of devices) {
        if (d && d.Shop) {
            if (d.Shop.id in shops) {
                shops[d.Shop.id].screen_nb++;
            } else {
                shops[d.Shop.id] = {
                    ...d.Shop,
                    screen_nb: 1
                };
            }
        }
    }

    return Object.values(shops);
};

export const getScreenPrice = (days: number[][], captive: boolean) => {
    const PRIX_BRUT_SEMAINE = captive ? 120 : 78;

    let factor = 0;

    for (let i = 0; i < days.length; i++) {
        // For each day of the week

        for (const h of days[i]) {
            // For each hour chosen
            factor += FACTORS[h][i];
        }
    }

    return (factor / 100) * PRIX_BRUT_SEMAINE;
};

export const hoursSum = (days: number[][], dStart: number, dEnd: number) => {
    let visibility = 0;

    for (let d = dStart; d <= dEnd; d++) {
        visibility += days[d].length;
        if (days[d].indexOf(22) !== -1) {
            visibility--;
        }
    }

    return visibility;
};

export const getScreenLog = (days: number[][], dStart: number, dEnd: number) => {
    let factor = 0;

    for (let d = dStart; d <= dEnd; d++) {
        for (const h of days[d]) {
            factor += FACTORS[h][d];
        }
    }

    return Math.round((factor / 100) * TICKETS_CAISSE * FACTEUR_MULTI * 7);
};

export const generateTimeBlocks = (week: number[][]) => {
    const blocks = [];

    const day = week[0];

    if (!week.every((d) => arrayEqual(d, day))) {
        return ['Custom'];
    }

    for (let i = 0; i < day.length; i++) {
        let j = i + 1;
        let end = day[i];
        while (j < day.length && day[j] === day[j - 1] + 1) {
            end = day[j];
            j++;
        }

        if (end === day[i]) {
            blocks.push(`${day[i]}h`);
        } else {
            blocks.push(`${day[i]} - ${end}`);
        }

        i = j - 1;
    }

    return blocks;
};

export const getWeeksNumbersFromCampaign = (startDate: Date, endDate: Date) => {
    const weeks = [];

    const cursor = new Date(startDate);
    cursor.setDate(cursor.getDate() - cursor.getDay() + 1);
    weeks.push(getWeekNumber(cursor));

    cursor.setDate(cursor.getDate() + 7);
    while (cursor < endDate) {
        weeks.push(getWeekNumber(cursor));
        cursor.setDate(cursor.getDate() + 7);
    }

    return weeks;
};

export const getNewPlanningAfterHoursRemoval = (planning: number[][], startDate: Date, endDate: Date) => {
    const newPlanning = planning.map((d) => d.map((h) => h));

    let dayStart = startDate.getDay() - 1;
    if (dayStart === -1) dayStart = 6;

    let maxHour = endDate.getHours();
    if (maxHour === 0 || maxHour > 22) {
        maxHour = 23;
    }

    for (let i = startDate.getHours(); i < maxHour; i++) {
        const idx = newPlanning[dayStart].findIndex((h) => h === i);

        if (idx === -1) {
            continue;
        }

        newPlanning[dayStart].splice(idx, 1);
    }

    return newPlanning;
};

export const saveNewCampaign = (campaign: ICampaign) => {
    const campaignData = campaign as any;
    delete campaignData.advertiser;
    delete campaignData.groupedIds;

    let agentId = 1;

    if (window.location.host === 'planning-sport.doohyoulike.com') agentId = 8;
    else if (window.location.host === 'planning-campus.doohyoulike.com') agentId = 10;

    return fetch(`${ENDPOINT}/${agentId}`, {
        headers: {
            'Content-Type': 'application/json',
            'x-planning-token': TOKEN
        },
        method: 'POST',
        body: JSON.stringify({
            ...campaignData
        })
    })
        .then((res) => {
            if (res.status === 200) {
                return res.json();
            }

            throw new Error();
        })
        .then(({ id }: { id: string }) => id);
};

export const updateCampaign = (campaign: ICampaign) => {
    const campaignData = { ...campaign } as any;
    const id = campaign.id;

    delete campaignData.advertiser;
    delete campaignData.groupedIds;
    delete campaignData.id;

    return fetch(`${ENDPOINT}/${id}`, {
        headers: {
            'Content-Type': 'application/json',
            'x-planning-token': TOKEN
        },
        method: 'PUT',
        body: JSON.stringify({
            ...campaignData
        })
    }).then((res) => {
        if (res.status === 200) {
            return Promise.resolve();
        }

        throw new Error();
    });
};

export const updateCampaignDevices = (campaignId: string, devicesToRemove: number[]) => {
    return fetch(`${ENDPOINT}/${campaignId}/devices`, {
        headers: {
            'Content-Type': 'application/json',
            'x-planning-token': TOKEN
        },
        method: 'PATCH',
        body: JSON.stringify({
            devices: devicesToRemove
        })
    }).then((res) => {
        if (res.status === 200) {
            return Promise.resolve();
        }

        throw new Error();
    });
};

export const deleteCampaign = (campaign: ICampaign) => {
    const id = campaign.id;

    return fetch(`${ENDPOINT}/${id}`, {
        headers: {
            'Content-Type': 'application/json',
            'x-planning-token': TOKEN
        },
        method: 'DELETE'
    }).then((res) => {
        if (res.status === 200) {
            return Promise.resolve();
        }

        throw new Error();
    });
};

export const signCampaign = (campaign: ICampaign) => {
    const id = campaign.id;

    return fetch(`${ENDPOINT}/${id}`, {
        headers: {
            'x-planning-token': TOKEN
        },
        method: 'PATCH'
    }).then((res) => {
        if (res.status === 200) {
            return res.json();
        }

        throw new Error();
    });
};

export const downloadScreenList = (devices: IDevice[], pois: any[], specialName: string | null = null) => {
    const rows = [
        'id_shop',
        'nom',
        'enseigne',
        'adresse',
        'code_postal',
        'ville',
        'nb_ecrans',
        'code_lsa',
        'lat',
        'lng'
    ];

    const devicesShops = getShopFromDevices(devices);

    const data = devicesShops.map((s: any) => ({
        id_shop: s.id,
        nom: s.name,
        enseigne: s.Sign.name,
        adresse: `${s.address}`,
        code_postal: s.zip,
        ville: s.city,
        nb_ecrans: s.screen_nb,
        code_lsa: '',
        lat: s.lat,
        lng: s.long
    }));

    XlsxPopulate.fromBlankAsync()
        .then((workbook: any) => {
            workbook.sheet(0).name('Ecrans');

            const letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'];
            for (let i = 0; i < letters.length; i++) {
                workbook.sheet(0).cell(`${letters[i]}${1}`).value(rows[i]);
            }

            for (let li = 0; li < data.length; li++) {
                for (let i = 0; i < letters.length; i++) {
                    workbook
                        .sheet(0)
                        .cell(`${letters[i]}${li + 2}`)
                        .value(Object.values(data[li])[i]);
                }
            }

            return workbook.outputAsync();
        })
        .then((blob: Blob) => {
            const a = document.createElement('a');
            document.body.appendChild(a);
            a.style.display = 'none';
            a.href = window.URL.createObjectURL(blob);
            if (specialName)
                a.download = specialName;
            else
                a.download = `planning-selection-${moment(new Date()).format('DD-MM-yy')}.xlsx`;
            a.click();
            window.URL.revokeObjectURL(a.href);
        });
};

export const geocode: (address: string) => Promise<IEntry> = (address: string) => {
    return new Promise((resolve) => {
        if (address.includes(';')) {
            const data = address.split(';');
            return resolve({
                address: data[0],
                lat: parseFloat(data[1]),
                lng: parseFloat(data[2])
            });
        }

        googleMapsClient.geocode(
            {
                address: `${address}`
            },
            async (res: any, err: any) => {
                if (err !== 'OK') {
                    console.log('Maps:', err);
                }

                if (err === 'OVER_QUERY_LIMIT') {
                    await new Promise((_resolve) => {
                        setTimeout(_resolve, 5000);
                    });

                    const addr = await geocode(address);

                    return resolve(addr);
                } else {
                    if (err !== 'OK') {
                        console.error(res, err);

                        return resolve({
                            address,
                            lat: 0,
                            lng: 0
                        });
                    }

                    setTimeout(() => {
                        return resolve({
                            address,
                            lat: res[0].geometry.location.lat(),
                            lng: res[0].geometry.location.lng()
                        });
                    }, 200);
                }
            }
        );
    });
};

const dist = (lat1: number, lon1: number, lat2: number, lon2: number) => {
    const R = 6371e3; // metres
    const phi1 = (lat1 * Math.PI) / 180; // phi, λ in radians
    const phi2 = (lat2 * Math.PI) / 180;
    const deltaPhi = ((lat2 - lat1) * Math.PI) / 180;
    const deltaLambda = ((lon2 - lon1) * Math.PI) / 180;

    const a =
        Math.sin(deltaPhi / 2) * Math.sin(deltaPhi / 2) +
        Math.cos(phi1) * Math.cos(phi2) * Math.sin(deltaLambda / 2) * Math.sin(deltaLambda / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    const d = R * c; // in metres

    return d;
};

export const getShopsIntersectingWithPoints = (devices: IDevice[], points: IEntry[], radius: number) => {
    const res: IDevice[] = [];
    const s = new Set();

    for (const entry of points) {
        for (const d of devices) {
            if (!d.Shop) {
                continue;
            }

            if (s.has(d.Shop.id)) {
                continue;
            }

            if (dist(entry.lat, entry.lng, d.Shop.lat, d.Shop.long) <= radius) {
                res.push(d);
            }
        }
    }

    return res;
};

export const generatePricingData = (
    w: number,
    startDate: Date,
    endDate: Date,
    planning: number[][],
    captive: boolean,
    screenNumber: number,
    slots: number,
    data: {
        totalLogs: number;
        totalAudience: number;
        totalContacts: number;
        totalBrut: number;
        totalAdserving: number;
        total: number;
    },
    logsArray: number[],
    contactsArray: number[],
    brutArray: number[],
    adServingArray: number[]
) => {
    let hoursNb = 'Custom';

    let cursor = dateFromWeekNumber(w, startDate);
    if (startDate > cursor) {
        cursor = startDate;
    }

    let cursorEnd = dateFromWeekNumber(w, startDate);
    cursorEnd.setDate(cursorEnd.getDate() + 7);

    let dEnd = cursorEnd.getDay() - 2;

    if (cursorEnd.getTime() > endDate.getTime() + 1) {
        cursorEnd = new Date(endDate);
        cursorEnd.setDate(cursorEnd.getDate() + 1);
        cursorEnd.setHours(0, 0, 0, 0);

        dEnd = cursorEnd.getDay() - 2;
    }

    let dStart = cursor.getDay() - 1;
    if (dStart === -1) dStart = 6;
    if (dEnd === -1) dEnd = 6;

    const prix_brut = Math.round(getScreenPrice(planning, captive) * screenNumber) * slots;
    data.totalBrut += prix_brut;
    const frais_tech = Math.max(250, Math.ceil(prix_brut * FRAIS_TECH));
    data.totalAdserving += frais_tech;

    if (planning[0].length !== 0) {
        if (!planning.every((d) => arrayEqual(d, planning[0]))) {
            hoursNb = 'Custom';
        } else {
            let hoursNbInt = planning[0].length;
            if (planning[0].indexOf(22) !== -1) {
                hoursNbInt--;
            }

            hoursNb = `${hoursNbInt}`;
        }
    }

    let logs = hoursSum(planning, dStart, dEnd) * 60 * slots * screenNumber;
    let audience = Math.ceil((getScreenLog(planning, dStart, dEnd) * screenNumber) / 2.8);
    let contacts = getScreenLog(planning, dStart, dEnd) * screenNumber;
    let sumPrices = prix_brut + frais_tech;

    data.totalLogs += logs;
    data.totalAudience += audience;
    data.totalContacts += contacts;
    data.total += sumPrices;

    logsArray.push(logs);
    contactsArray.push(contacts);
    brutArray.push(prix_brut);
    adServingArray.push(frais_tech);

    return { cursor, cursorEnd, hoursNb, logs, audience, contacts, prix_brut, frais_tech, sumPrices };
};

export const downloadRecap = (
    projectName: string,
    weeks: number[],
    startDate: Date,
    endDate: Date,
    planning: number[][],
    captive: boolean,
    screenNumber: number,
    slots: number,
    shopsNumber: number
) => {
    var req = new XMLHttpRequest();
    req.open('GET', 'template_pricer.xlsx', true);
    req.responseType = 'arraybuffer';
    req.onreadystatechange = function () {
        if (req.readyState === 4 && req.status === 200) {
            XlsxPopulate.fromDataAsync(req.response)
                .then(function (workbook: any) {
                    const sheet = workbook.sheet('Feuil1');

                    sheet.cell('E1').value(`PROJET CAMPAGNE : ${projectName}`);
                    sheet.cell('E2').value(`crée le : ${moment().format('DD/MM/yyyy')}`);

                    let line = 5;

                    const totalVariables = {
                        totalLogs: 0,
                        totalAudience: 0,
                        totalContacts: 0,
                        totalBrut: 0,
                        totalAdserving: 0,
                        total: 0
                    };

                    const logsArray: number[] = [];
                    const contactsArray: number[] = [];
                    const brutArray: number[] = [];
                    const adServingArray: number[] = [];

                    for (const w of weeks) {
                        const data = generatePricingData(
                            w,
                            startDate,
                            endDate,
                            planning,
                            captive,
                            screenNumber,
                            slots,
                            totalVariables,
                            logsArray,
                            contactsArray,
                            brutArray,
                            adServingArray
                        );

                        sheet.cell(`A${line}`).value(w);
                        sheet.cell(`B${line}`).value(moment(data.cursorEnd).diff(data.cursor, 'days'));
                        sheet.cell(`C${line}`).value(moment(data.cursor).format('DD/MM/yyyy'));
                        sheet.cell(`D${line}`).value(moment(data.cursorEnd).format('DD/MM/yyyy'));
                        sheet.cell(`E${line}`).value(10);
                        sheet.cell(`F${line}`).value(slots);
                        sheet
                            .cell(`G${line}`)
                            .value(
                                planning[0].length || generateTimeBlocks(planning).reduce((acc, t) => acc + ' + ' + t)
                            );
                        sheet.cell(`H${line}`).value(data.hoursNb);
                        sheet
                            .cell(`I${line}`)
                            .value(planning.reduce((acc, d) => acc + d.length + (d.indexOf(22) !== -1 ? -1 : 0), 0));
                        sheet.cell(`J${line}`).value(shopsNumber);
                        sheet.cell(`K${line}`).value(screenNumber);
                        sheet.cell(`L${line}`).value(data.logs);
                        sheet.cell(`M${line}`).value(data.contacts);
                        sheet.cell(`N${line}`).value(data.prix_brut);
                        sheet.cell(`O${line}`).value(data.frais_tech);
                        sheet.cell(`P${line}`).value(data.frais_tech + data.prix_brut);

                        line++;
                    }

                    return workbook.outputAsync();
                })
                .then((blob: Blob) => {
                    const a = document.createElement('a');
                    document.body.appendChild(a);
                    a.style.display = 'none';
                    a.href = window.URL.createObjectURL(blob);
                    a.download = `planning-recap-${moment(new Date()).format('DD-MM-yy')}.xlsx`;
                    a.click();
                    window.URL.revokeObjectURL(a.href);
                });
        }
    };

    req.send();
};

export const uploadScreenList: (devices: IDevice[]) => Promise<number[] | null> = async (devices: IDevice[]) => {
    const fInput = document.createElement('input');
    fInput.type = 'file';
    fInput.accept = '*.xlsx';
    fInput.style.display = 'none';
    document.body.appendChild(fInput);

    return new Promise((resolve) => {
        fInput.addEventListener('change', (e: any) => {
            if (!e.target.files[0]) {
                return null;
            }

            const file = e.target.files[0];

            const devices_matching: number[] = [];

            return XlsxPopulate.fromDataAsync(file).then((workbook: any) => {
                const shopIds: number[] = [];

                let i = 2;
                let value = workbook.sheet(0).cell(`A${i}`).value();
                do {
                    shopIds.push(value);
                    value = workbook
                        .sheet(0)
                        .cell(`A${i++}`)
                        .value();
                } while (value);

                for (const device of devices) {
                    if (!device.Shop) {
                        continue;
                    }

                    if (shopIds.includes(device.Shop.id)) {
                        devices_matching.push(device.id);
                    }
                }

                fInput.remove();
                return resolve(devices_matching);
            });
        });

        fInput.click();
    });
};
